import styled, { css } from 'styled-components';
import Markdown from 'react-markdown';

import { MODAL_BLUE, THEME_COLORS } from '../../utils/colors';
import { ContentMain } from '../layout/layout.styles';
import { PartnersListContainer } from '../partnersList/partnersList.styles';
import { media } from '../../utils/media';

export const ContentModal = styled.div`
  ${PartnersListContainer} {
    --columns-number: 1;
    grid-gap: 40px;
    margin-top: 40px;

    @media (min-width: 400px) {
      --columns-number: 2;
    }

    ${media.tablet`
      --columns-size: 140px;
      --columns-number: 2;
      grid-gap: 80px;
    `}

    ${media.desktop`
      --columns-number: 3;
    `}
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;

  ${media.desktop`
    flex-direction: row;
    align-items: unset;
  `}
`;

export const Header = styled.h2`
  font-size: 10px;
  font-weight: 600;
  line-height: 1.8em;
  letter-spacing: 0.25px;
  color: ${MODAL_BLUE};
  text-transform: uppercase;
  margin-bottom: 3px;
`;

export const MainHeader = styled.h1`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.4px;
  color: ${MODAL_BLUE};
  text-transform: uppercase;
`;

const hStyles = css`
  h1 {
    font-size: 21px;
    font-weight: normal;
    letter-spacing: -0.15px;
    line-height: normal;
    max-width: 100%;
    color: ${THEME_COLORS.GREYISH_BROWN};
    width: 100%;

    ${media.desktop`
      width: unset;
    `}
  }
`;

const textStyles = css`
  font-size: 12px;
  font-weight: 300;
  line-height: 1.5em;
  margin-bottom: 1.6em;
  margin-right: 0;
`;

const olStyles = () => css`
  ol {
    counter-reset: item;
    list-style-type: none;
    margin: 0 0 13px;
  }

  li {
    font-size: 12px;
    font-weight: 300;
    line-height: 1.5em;
    margin-bottom: 0.6em;
  }
`;

export const MarkdownContent = styled(Markdown)`
  margin-left: 0;

  ${media.desktop`
    width: ${({ short }) => (short ? 85 : 100)}%;
  `}
`;

export const Main = styled(ContentMain)`
  margin-left: 0 !important;
  padding-top: 10px;
  ${({ noBorder }) => (noBorder ? null : `border-top: 2px solid ${MODAL_BLUE}`)};

  ${MarkdownContent} {
    ${hStyles}
    ${olStyles}

    > p {
      ${textStyles}
    }
  }

  > span {
    ${textStyles}
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  margin: 10px;
  width: 100%;
  ${({ noMargin }) => (noMargin ? `margin-top: 0; padding-top: 0;` : null)};

  ${media.desktop`
    ${({ main }) => (main ? `max-width: 100%;` : `max-width: 50%;`)};
  `}
`;
